import React, { useCallback, useEffect, useState } from 'react'
import { Button, Typography } from 'antd'
import { useAuthContext } from 'contexts/AuthContext'
import { collection, getDocs, query } from 'firebase/firestore'
import { firestore } from 'config/firebase'

const { Title } = Typography

export default function Home() {

    const { user, handleLogout } = useAuthContext()
    const [documents, setDocuments] = useState([])

    const readUsers = useCallback(async () => {
        const q = query(collection(firestore, "users"));

        const querySnapshot = await getDocs(q);

        const array = []
        querySnapshot.forEach(doc => {
            const document = doc.data()

            array.push(document)
        })

        setDocuments(array)
    }, [])
    useEffect(() => { readUsers() }, [readUsers])

    return (
        <>
            <div className="container">
                <Title level={1}>Email: {user.email}</Title>
                <Title level={1}>UID: {user.uid}</Title>
                <Title level={1}>Total Users Length: {documents.length}</Title>

                <hr />
                <Button type='primary' danger onClick={handleLogout}>Logout</Button>
            </div>
        </>
    )
}
